import React, { useCallback, useEffect } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { QRCodeSVG } from 'qrcode.react';
import { MdHourglassEmpty, MdRefresh } from 'react-icons/md';

import { loadValidationRequest } from '~/store/modules/pickupValidation/actions';
import { CodeBox, WaitingIndicator, Button, ModalFooter } from '../styles';

const POLL_INTERVAL_MS = 15000;

export default function StepAwaitingDispatch({ cartId }) {
  const dispatch = useDispatch();
  const { validation, loading } = useSelector(state => state.pickupValidation);

  const { pickup_code: pickupCode } = validation;

  const handleRefresh = useCallback(() => {
    dispatch(loadValidationRequest(cartId));
  }, [dispatch, cartId]);

  // Polling de fallback: se o websocket não chegar, recarrega sozinho.
  // Como esse step só renderiza em awaiting_dispatch, o polling cessa
  // automaticamente quando a sessão transita pra dispatched/released/canceled.
  useEffect(() => {
    const interval = setInterval(() => {
      dispatch(loadValidationRequest(cartId));
    }, POLL_INTERVAL_MS);

    return () => clearInterval(interval);
  }, [dispatch, cartId]);

  function renderCode() {
    if (!pickupCode || !pickupCode.required || !pickupCode.value) {
      return (
        <CodeBox>
          <div className="hint">
            Aguarde o entregador acionar a coleta no aplicativo dele.
          </div>
        </CodeBox>
      );
    }

    if (pickupCode.type === 'qrcode') {
      return (
        <CodeBox>
          <div className="label">
            Mostre este QR Code para o entregador escanear:
          </div>
          <QRCodeSVG value={pickupCode.value} size={160} />
        </CodeBox>
      );
    }

    if (pickupCode.type === 'pin') {
      return (
        <CodeBox>
          <div className="label">Informe este código ao entregador:</div>
          <div className="pin">{pickupCode.value}</div>
        </CodeBox>
      );
    }

    return null;
  }

  return (
    <>
      {renderCode()}

      <WaitingIndicator>
        <MdHourglassEmpty size={18} />
        Aguardando o entregador iniciar a corrida...
      </WaitingIndicator>

      <ModalFooter style={{ padding: '20px 0 0', border: 0 }}>
        <Button
          type="button"
          variant="ghost"
          onClick={handleRefresh}
          disabled={loading}
        >
          <MdRefresh size={16} style={{ verticalAlign: 'middle' }} />{' '}
          {loading ? 'Atualizando...' : 'Atualizar status'}
        </Button>
      </ModalFooter>
    </>
  );
}
